import { takeLatest, call, put, all } from 'redux-saga/effects';
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CRV } from 'services/_path';
import { ReducerAction } from 'store/modules/types';
import { IImpressaoComunicacaoVenda } from 'pages/DetranCrv/Processos/ImpressaoComunicacaoVenda/Consulta/form';
import { Types } from './types';
import {
	impressaoComunicacaoVendaSuccess,
	impressaoComunicacaoVendaFailure,
} from './actions';

function* impressaoComunicacaoVendaRequest(request: ReducerAction) {
	const { payload }: { payload: IImpressaoComunicacaoVenda } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CRV,
		`processos/${CHANNEL}/impressao/comunicacoes-vendas`,
		payload,
	);
	if (response.status === 200 || response.status === 201) {
		yield put(impressaoComunicacaoVendaSuccess(response));
	} else if (response.error) {
		yield put(impressaoComunicacaoVendaFailure(response.message));
	}
}

export default all([
	takeLatest(
		Types.IMPRESSAO_COMUNICACAO_VENDA_REQUEST,
		impressaoComunicacaoVendaRequest,
	),
]);
